import React from 'react';
import { Box, Typography } from '@mui/material';

const ReportsPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Reports & Analytics
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Reporting and analytics functionality will be implemented here.
      </Typography>
    </Box>
  );
};

export default ReportsPage;
